import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {MatTextareaAutosize} from '@angular/material';

@Component({
    selector: 'title-component',
    templateUrl: 'title.component.html'
})
export class TitleComponent {
    placeholder = 'Article Title';

    @Input() canEdit?: boolean;
    @Input() title;
    @Input() hidePlaceholder;

    @Output() titleChange = new EventEmitter();

    @ViewChild('textarea') textarea: MatTextareaAutosize;

    constructor() {}
    ngAfterViewInit() {
        setTimeout(() => {
            this.textarea.resizeToFitContent(true);
        }, 1000);        
    }

    changeTitle() {
        this.title = this.title.trim();
        this.titleChange.emit(this.title);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/title.component.ts